import React, { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import './ReactQuillEditor.css';
import ImageResize from 'quill-image-resize-module-react';
import Quill from 'quill';

// ลงทะเบียน module

Quill.register('modules/imageResize', ImageResize);

const modules = {
  toolbar: {
    container: [
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image']
      [{ 'align': [] }], // <-- จัดตำแหน่ง
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean']
    ],
    imageResize: true,
    handlers: {
      image: function () {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
          const file = input.files[0];
          const formData = new FormData();
          formData.append('image', file);

          try {
            const res = await axios.post(`${API_BASE_URL}/api/uploads/news-image`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });

            const range = this.quill.getSelection();
            this.quill.insertEmbed(range.index, 'image', `${API_BASE_URL}/uploads/news/${res.data.filename}`);
          } catch (err) {
            console.error('Upload failed', err);
          }
        };
      },
    },
  },
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'align', // <-- สำคัญ: บอกให้ Quill รู้ว่าใช้ align ได้
  'list', 'bullet',
  'link', 'image'
];
const RichTextEditor = ({ value, onChange }) => {
  const quillRef = useRef();


  useEffect(() => {
    const images = document.querySelectorAll('.ql-editor img');
    images.forEach((img) => {
      img.style.maxWidth = '50%';
      img.style.height = 'auto';
      img.style.display = 'block';
      img.style.margin = '1rem auto';
    });
  }, [value]);


  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      modules={modules}
      formats={formats}
      value={value}
      onChange={onChange}
      style={{ height: '400px' }}
    />
  );
};

export default RichTextEditor;
